import { ENDPOINT } from '../appConfig'

export interface ListInterest {
  interestPeriod: number
  interestRate: string
  interestRateCreated: string
  referenceId: string
  termsEndDate: string
  termsEndDateCreated: string
}

export async function fetchMortgageRates() {
  try {
    const response = await fetch(ENDPOINT.MORTGAGE_RATES)
    const data: { listInterests: ListInterest[] } = await response.json()
    return {
      successful: true,
      data: data.listInterests,
    }
  } catch (err) {
    return {
      successful: false,
      data: [],
    }
  }
}

export interface MortgageTerms {
  maxTotalDebtForResidence: number
  minLivingSpaceForCondo: number
  maxLivingSpaceForCondo: number
  minLivingSpaceForHouse: number
  maxLivingSpaceForHouse: number
  minMaritalStatus: number
  maxMaritalStatus: number
  maxLoanToValueRatioMortgage: number
  maxLoanToValueRatioMortgageAndPersonalLoan: number
  maxLoanAmountForSecondaryHouse: number
  minLoanAmountMortgage: number
  maxLoanAmountMortgage: number
  maxLoanAmountMortgageAndPersonalLoan: number
  minDeposit: number
  maxDeposit: number
  minHousePrice: number
  minLoanAmountForIncreasedMortgage: number
  minDownPayment: number
  minAgeForLoan: number
  retirementAgeLimit: number
}

export async function fetchMortgageTerms() {
  try {
    const response = await fetch(ENDPOINT.PRODUCT_TERMS_MORTAGE)
    const data: MortgageTerms = await response.json()
    return {
      successful: true,
      data,
    }
  } catch (err) {
    return {
      successful: false,
      data: null,
    }
  }
}

export interface PersonalLoanTerms {
  lenderList: string[]
  minAmountOfMonthsRepaymentTime: number
  maxAmountOfMonthsRepaymentTime: number
  minMaritalStatus: number
  maxMaritalStatus: number
  maxLoanAmountUnsecuredLoan: number
  minPersonalLoanAmount: number
  maxPersonalLoanAmount: number
  minAgeForPersonalLoan: number
  minAnnualIncomeOneApplicant: number
  minAnnualIncomeMultipleApplicants: number
  minAmountForRedemptionOfLoan: number
}

export async function fetchPersonalLoanTerms() {
  try {
    const response = await fetch(ENDPOINT.PRODUCT_TERMS_PERSONAL_LOAN)
    const data: PersonalLoanTerms = await response.json()
    return {
      successful: true,
      data,
    }
  } catch (err) {
    return {
      successful: false,
      data: null,
    }
  }
}

interface RateObj {
  id: string
  name: string
  rate: string
  effectiveRate: string
  validFrom: string
}

export async function fetchExampleRate() {
  try {
    const response = await fetch(ENDPOINT.PERSONAL_LOAN_EXAMPLE_RATE)
    const data: { items: RateObj[] } = await response.json()
    return {
      successful: true,
      data,
    }
  } catch (err) {
    return {
      successful: false,
      data: null,
    }
  }
}

interface InterestDeviation {
  priceDifference: string
  priceComponents: {
    type: string
    priceDifference: string
  }[]
  productOfferId: string
  priceDifferenceSpecification: {
    description: string
    priceDifferenceItems: {
      priceDifference: string
      description: string
      calculationName: string
      type: string
    }[]
    limited: boolean
  }
}

export async function fetchInterestDeviation(
  marketValue: number,
  mortgageAmount: number
) {
  const body = JSON.stringify({
    marketValue: Math.round(marketValue),
    mortgageAmount: Math.round(mortgageAmount),
  })
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }
  try {
    const response = await fetch(
      ENDPOINT.MORTGAGE_PRICE_MATRIX_DIFFERENCE,
      options
    )
    const data: InterestDeviation = await response.json()
    return {
      successful: true,
      data,
    }
  } catch (err) {
    return {
      successful: false,
      data: null,
    }
  }
}
